import {
  Box,
  Code,
  Container,
  Heading,
  Tag,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useRouteError } from "react-router-dom";

type RouteErrorData = {
  title?: string;
  message?: string;
};

type RouteError = {
  data?: RouteErrorData;
};

function isRouteError(error: unknown): error is RouteError {
  return typeof error === "object" && error !== null && "data" in error;
}

export function NotFound404Screen() {
  const isDev = import.meta.env.DEV;
  const error = useRouteError();
  const routeError = isRouteError(error) ? error : null;
  const title =
    routeError?.data?.title ?? "The page you are looking for does not exist.";
  const message = routeError?.data?.message;

  return (
    <Container maxW={"2xl"} pt={"32"}>
      <VStack spacing={"4"} w={"100%"}>
        <Heading>Page not found</Heading>
        <Text>{title}</Text>
        {isDev && (
          <Box
            borderColor={"orange.300"}
            borderWidth={2}
            w={"100%"}
            maxW={"400px"}
            bg={"orange.50"}
            borderStyle={"dashed"}
            p={4}
            borderRadius={4}
            textAlign={"center"}
            style={{
              // @ts-expect-error Exists
              textWrap: "balance",
            }}
          >
            <Text>
              {message ?? (
                <>
                  <Tag colorScheme={"orange"} bgColor={"orange.300"} mr={2}>
                    DEV
                  </Tag>
                  Check that your URL starts with a proper region prefix e.g.{" "}
                  <Code colorScheme={"orange"}>/local/listing/1</Code>
                </>
              )}
            </Text>
          </Box>
        )}
      </VStack>
    </Container>
  );
}
